import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  Button,
  Toolbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import EditWrap from "../../commonComponent/editWrap";
import axiosWithToken from "../../../utils/components/axiosTokenConfig";
import { BASE_URL } from "../../../global";
import {
  fetchReservefromandto,
  fetchSRFList,
  generateSRFRange,
} from "../../srf/editSrf/fetchHandlers";
import { toast } from "react-toastify";

const ReservedSRFTable = () => {
  const [srfNo, setsrfNo] = useState("");
  const [lastULRNo, setLastULRNo] = useState("");
  const [ULRNo, setULRNo] = useState("");
  const [fromValue, setFromValue] = useState("");
  const [toValue, setToValue] = useState("");
  const [error, setError] = useState("");
  const [toError, setToError] = useState("");
  const [reservedSrfId, setReservedSrfId] = useState(null);
  const [reservedSrfSeriesList, setreservedSrfSeriesList] = useState([]);
  const getLastSRFNo = () => {
    axiosWithToken
      .post(BASE_URL + "dynamic", {
        query:
          "SELECT id, serviceReqNumber FROM srfs WHERE calType = 1 AND reservedSrf = 0 AND status = 1 ORDER BY id DESC LIMIT 1;",
      })
      .then((res) => setsrfNo(res.data[0]?.serviceReqNumber))
      .catch((err) => console.log(err));
  };

  const getLastULRNo = () => {
    axiosWithToken
      .post(BASE_URL + "dynamic", {
        query:
          "SELECT id, ULRNo FROM certificates WHERE calibrationType = 1 AND reservedSrf = 0 AND status = 1 ORDER BY id DESC LIMIT 1;",
      })
      .then((res) => setLastULRNo(res.data[0]?.ULRNo))
      .catch((err) => console.log(err));
  };

  const getreservedSrfSeriesList = () => {
    axiosWithToken
      .post(BASE_URL + "dynamic", {
        query:
          "SELECT * from reservedSrfSeries where status = 1 ORDER BY id DESC;",
      })
      .then((res) => setreservedSrfSeriesList(res.data))
      .catch((err) => console.log(err));
  };

   useEffect(() => {
    getLastSRFNo();
    getreservedSrfSeriesList();
    getLastULRNo();
  }, []);

  const lastSRFNumber = parseInt(srfNo?.split("/").pop(), 10) || 0;

  const handleFromChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      if (value && parseInt(value, 10) <= lastSRFNumber) {
        setError(`Value must be greater than ${lastSRFNumber}`);
      } else {
        setError("");
      }
      setFromValue(value);
    }
  };

  const handleToChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      if (parseInt(value, 10) < parseInt(fromValue, 10)) {
        setToError("'To' value must be greater than or equal to 'From' value.");
      } else {
        setToError("");
      }
      setToValue(value);
    }
  };

  const fetchAndFilterSRFNumbers = async () => {
    try {
      let srfDetails = {
        calType: 1,
        serviceReqNumber: srfNo,
      };

      const response = await fetchSRFList();
      const existingNumbers = new Set(
        response
          ?.map((item) => item.serviceReqNumber) || []
      );
      const fetchReservefromandtodata = await fetchReservefromandto();
      let lastfromandto = fetchReservefromandtodata?.[0]?.reservedSrfCount;
      let updatedsrflist = generateSRFRange(lastfromandto,srfDetails).filter((newValue) => {
        const lastNumber = newValue?.split("/").pop(); // Extract last number
        return ![...existingNumbers]?.some((existing) =>
          existing.endsWith(`/${lastNumber}`)
        );
      });
      return updatedsrflist;
    } catch (error) {
      console.error("Error fetching SRF list:", error);
      return [];
    }
  };

  const handleSubmit = async () => {
    if (!fromValue || !toValue) {
      setError("Both fields are required.");
      return;
    }
    if (parseInt(toValue, 10) < parseInt(fromValue, 10)) {
      setToError("'To' value must be greater than or equal to 'From' value.");
      return;
    }

    let reserveSRFList = await fetchAndFilterSRFNumbers();
    if (reserveSRFList.length > 0) {
      alert(
        "you can't update because previous reserved series is not created ."
      );
      return;
    }
    axiosWithToken
      .post(BASE_URL + `reservedSrfSeries`, {
        reservedSrfCount: `${fromValue}-${toValue}`,
        reservedSrf: srfNo,
        reservedUlrCount:ULRNo,
        reservedUlr:lastULRNo,
        status: 1,
      })
      .then(() => {
        toast.success("SRF Range Reserved Successfully!");
        setFromValue("");
        setToValue("");
        window.location.reload();
      })
      .catch((err) => console.log(err));
  };

  const handleDelete = () => {
    if (reservedSrfId) {
      axiosWithToken
        .delete(BASE_URL + `settings/${reservedSrfId}`)
        .then(() => {
          toast.error("Reserved SRF Deleted Successfully!");
          setFromValue("");
          setToValue("");
          setReservedSrfId(null);
        })
        .catch((err) => console.log(err));
    }
  };

  useEffect(() => {
    if (lastSRFNumber) {
      setFromValue((lastSRFNumber + 1).toString());
    }
  }, [lastSRFNumber]);

  return (
    <EditWrap>
      <Typography variant="h6" component="h6" style={{ float: "left" }}>
        Reserved SRF
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            fullWidth
            label="Last Srf"
            variant="outlined"
            size="small"
            value={srfNo}
            disabled
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            fullWidth
            label="from"
            variant="outlined"
            size="small"
            value={fromValue}
            onChange={handleFromChange}
            error={!!error}
            helperText={error}
            disabled
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            fullWidth
            label="Enter To"
            variant="outlined"
            size="small"
            value={toValue}
            onChange={handleToChange}
            error={!!toError}
            helperText={toError}
          />
        </Grid>
      </Grid>
<br/>
      <Typography variant="h6" component="h6" style={{ float: "left" }}>
        Reserved ULR
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            fullWidth
            label="Last ULR"
            variant="outlined"
            size="small"
            value={lastULRNo}
            disabled
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            fullWidth
            label="Enter ULR Reserved count"
            variant="outlined"
            size="small"
            value={ULRNo}
            onChange={(e)=>setULRNo(e.target.value)}
          />
        </Grid>

      </Grid>

      <Toolbar
        style={{
          padding: "0px",
          overflow: "auto",
          display: "flex",
          justifyContent: "flex-end",
          gap: "20px",
          marginTop: "3rem",
        }}
      >
        <Button
          variant="contained"
          style={{ backgroundColor: "grey" }}
          size="small"
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        >
          Cancel
        </Button>
        {reservedSrfId && (
          <Button
            variant="contained"
            color="error"
            onClick={handleDelete}
            sx={{ m: 0 }}
            size="small"
          >
            Delete
          </Button>
        )}
        <Button
          variant="contained"
          size="small"
          sx={{ m: 0 }}
          onClick={handleSubmit}
        >
          Save
        </Button>
      </Toolbar>

      {/* Table to show From and To */}
      <TableContainer
        style={{ marginTop: "2rem" }}
        size="small"
        sx={{ borderCollapse: "collapse" }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "20%", padding: "5px" }}>
                <strong>Srf No</strong>
              </TableCell>{" "}
              <TableCell style={{ width: "20%", padding: "5px" }}>
                <strong>From</strong>
              </TableCell>
              <TableCell style={{ width: "20%", padding: "5px" }}>
                <strong>To</strong>
              </TableCell>              
              <TableCell style={{ width: "20%", padding: "5px" }}>
                <strong>Last ULR</strong>
              </TableCell>              
              <TableCell style={{ width: "20%", padding: "5px" }}>
                <strong>ULR Reserved</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reservedSrfSeriesList?.map((item) => {
              const [from, to] = item.reservedSrfCount?.split("-");

              return (
                <TableRow key={item.id}>
                  <TableCell style={{ padding: "5px" }}>
                    {item.reservedSrf}
                  </TableCell>
                  <TableCell style={{ padding: "5px" }}>{from}</TableCell>
                  <TableCell style={{ padding: "5px" }}>{to}</TableCell>
                  <TableCell style={{ padding: "5px" }}>{item?.reservedUlr}</TableCell>
                  <TableCell style={{ padding: "5px" }}>{item?.reservedUlrCount}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </EditWrap>
  );
};

export default ReservedSRFTable;
